import { ColDef, GridOptions, GridReadyEvent } from '@ag-grid-community/core'
import { Component, Input, OnInit } from '@angular/core'
import {
  enableHeliosCopyBehavior,
  enableHeliosGridDensityLevel,
  enableHeliosMultiRowDragSelection,
  heliosMultiRowSelectionConfig,
} from '@helios/ag-grid-config'
import { CreateApprovalResponse } from '@helios/commands'
import { DensityLevel, UserPreferencesService } from '@helios/user-preferences'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { AgGridApi } from '@northfork/ag-grid'
import { composeFieldPath } from '@northfork/basics'
import { Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'

const field = composeFieldPath([] as CreateApprovalResponse[])

@Component({
  selector: 'approval-request-failed-accounts',
  templateUrl: './approvals-request-failed-accounts.component.html',
  styleUrls: ['./approvals-request-failed-accounts.component.scss'],
})
export class ApprovalsRequestFailedAccountsComponent implements OnInit {
  @Input()
  failedAccounts: CreateApprovalResponse[] = []
  hideRequestIdCol = false
  gridOptions: GridOptions = this.createGridOptions()

  constructor(
    public activeModal: NgbActiveModal,
    private readonly preferences: UserPreferencesService,
  ) {}
  ngOnInit(): void {
    this.hideRequestIdCol = !this.failedAccounts.some(item => item.requestId)
    this.gridOptions = this.createGridOptions()
  }

  gridApi?: AgGridApi
  private readonly destroySubject$ = new Subject<void>()

  private createColumnDefs(): ColDef[] {
    const colDef = [
      {
        field: field('requestId'),
        headerName: 'Request Id',
        hide: this.hideRequestIdCol,
      },
      {
        field: field('reconDate'),
        headerName: 'Recon Date',
      },
      {
        field: field('accountIds'),
        headerName: 'Accounts',
      },
      {
        field: field('message'),
        headerName: 'Message',
      },
    ]

    return colDef
  }

  createGridOptions(): GridOptions {
    return {
      ...heliosMultiRowSelectionConfig,
      columnDefs: this.createColumnDefs(),
      defaultColDef: {
        sortable: true,
        filter: true,
      },
      onGridReady: event => this.onGridReady(event),
      suppressRowClickSelection: false,
      sideBar: false,
    }
  }

  /** @internal */
  onGridReady(event: GridReadyEvent) {
    this.gridApi = event
    this.preferences
      .getDensityLevel()
      .pipe(takeUntil(this.destroySubject$))
      .subscribe(level =>
        enableHeliosGridDensityLevel(event.api, DensityLevel.Compact === level),
      )
    enableHeliosMultiRowDragSelection(this.gridApi.api)
    enableHeliosCopyBehavior(this.gridApi.api)
  }
}
